import { render, staticRenderFns } from "./Outcomes.vue?vue&type=template&id=12d962c8&scoped=true&"
import script from "./Outcomes.vue?vue&type=script&lang=js&"
export * from "./Outcomes.vue?vue&type=script&lang=js&"
import style0 from "./Outcomes.vue?vue&type=style&index=0&id=12d962c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d962c8",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QInput,QIcon,QCard,QDialog});
